"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthContent = exports.MonthName = exports.Month = exports.Week = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../../../assets/styles/colors");
const media_1 = require("../../../../../utils/media");
const DAY_GAP = "10px";
const Week = styled_components_1.default.div `
  display: flex;
  gap: ${DAY_GAP};
  width: 100%;
  height: 100%;
`;
exports.Week = Week;
const Month = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: 3rem;
  @media (${media_1.media.smallDesktop}) {
    padding-bottom: 0;
  }
  @media (${media_1.media.desktop}) {
    width: 33.33%;
  }
`;
exports.Month = Month;
const MonthName = styled_components_1.default.span `
  font-size: 16px;
  letter-spacing: 6px;
  text-transform: uppercase;
  font-weight: 500;
  color: ${colors_1.gray400};
  padding: 0.625rem;
  line-height: 100%;
  text-align: center;
  background-color: ${colors_1.gray100};
  margin-bottom: 2.5rem;

  @media (${media_1.media.smallDesktop}) {
    font-size: 24px;
    border-radius: 10px;
    letter-spacing: 0;
    text-transform: none;
  }
`;
exports.MonthName = MonthName;
const MonthContent = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
`;
exports.MonthContent = MonthContent;
